import { axiosInstance } from "api/axios";
import { useQuery } from "react-query";
import { IRiskProfileReminderStatus } from "./types";

export const RISK_PROFILE_REMINDER_STATUS_KEY = "/risk-profile/reminder-status";

export const useRiskProfileReminderStatus = (options?: any) => {
	return useQuery<IRiskProfileReminderStatus>(
		[RISK_PROFILE_REMINDER_STATUS_KEY],
		async () => {
			const { data } = await axiosInstance.get(`/risk-profile/reminder-status`);
			return data;
		},
		options,
	);
};
